<template>
  <div
    :class="[
      'mb-2 animate-pulse rounded-md bg-neutral-200 transition ease-in-out',
      width === 'half' ? 'w-1/2' : 'w-full',
      size === 'large' ? 'h-8' : size === 'medium' ? 'h-6' : 'h-4',
      space === 'large' ? 'mb-6' : space === 'medium' ? 'mb-4' : 'mb-2',
    ]"
  ></div>
</template>
<script lang="ts" setup>
defineProps<{
  width?: 'full' | 'half';
  size?: 'small' | 'medium' | 'large';
  space?: 'small' | 'medium' | 'large';
}>();
</script>
